import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import ApkLoanAssetService from "services/Setup/LoanOrigination/ApkLoanAsset/ApkLoanAssetService";
import { notification, Modal } from "antd";
import assetsEdit from "assets/data/sempelresponeditkkb/assets.json";

export const initialState = {
  loading: false,
  loadingAsset: false,
  loadingRequiredFees: false,
  loadingAssetRegis: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  productList: {},
  refreshList: false,
  getPageSize: "",
  getPageIndex: "",
  getCount: "",
  requiredAssetDocList: [],
  requiredAssetFeeList: [],
  attributeValidationItem: [],
  getEditAssetItem: [],
  // getEditAssetItem: assetsEdit || [],
  getMRPItem: [],
  statusRespon: 0,
  noApkFAS: "",
  creditStepKTA: null,
};

export const getRequiredAssetDocSlice = createAsyncThunk(
  "ApprovalKredit/getRequiredAssetDocSlice",
  async (prospectid, { rejectWithValue }) => {
    try {
      const response = await ApkLoanAssetService.getRequiredAssetDocService(
        prospectid
      );

      if (response.status === 200 && response.data) {
        return response.data;
      }

      notification.error({
        message: "Error",
        description: response?.data?.message || "Unexpected response!",
        duration: 3,
      });

      return rejectWithValue(response?.data?.message || "Unexpected response!");
    } catch (error) {
      const status = error?.response?.status || "Error";
      const statusText = error?.response?.statusText || "Unexpected error";

      notification.error({
        message: status,
        description: statusText,
        duration: 3,
      });

      return rejectWithValue(error?.response?.data?.message || statusText);
    }
  }
);

export const addApkLoanAssetSlice = createAsyncThunk(
  "ApprovalKredit/addApkLoanAssetSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await ApkLoanAssetService.addApkLoanAssetService(
        userInput
      );

      if (response.status === 200) {
        const { status, message: desc } = response.data;

        if (status === "Success") {
          notification.success({
            message: status,
            description: desc,
            duration: 3,
          });
        } else {
          notification.error({
            message: status,
            description: desc,
            duration: 3,
          });
        }

        return response.data;
      }

      notification.error({
        message: "Error",
        description: response?.data?.message || "Unexpected response!",
        duration: 3,
      });

      return rejectWithValue(response?.data?.message || "Unexpected response!");
    } catch (error) {
      const statusText =
        error?.response?.data?.message || "Unexpected response!";
      notification.error({
        message: "Error",
        description: statusText,
        duration: 3,
      });

      return rejectWithValue(statusText);
    }
  }
);

export const editApkLoanAssetSlice = createAsyncThunk(
  "ApprovalKredit/editApkLoanAssetSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await ApkLoanAssetService.editApkLoanAssetService(
        userInput
      );

      if (response.status === 200) {
        const { status, message: desc } = response.data;

        if (status === "Success") {
          notification.success({
            message: status,
            description: desc,
            duration: 3,
          });
        } else {
          notification.error({
            message: status,
            description: desc,
            duration: 3,
          });
        }

        return response.data;
      }

      notification.error({
        message: "Error",
        description: response?.data?.message || "Unexpected response!",
        duration: 3,
      });

      return rejectWithValue(response?.data?.message || "Unexpected response!");
    } catch (error) {
      const statusText =
        error?.response?.data?.message || "Unexpected response!";
      notification.error({
        message: "Error",
        description: statusText,
        duration: 3,
      });

      return rejectWithValue(statusText);
    }
  }
);

export const getRequiredFeesSlice = createAsyncThunk(
  "ApprovalKredit/getRequiredFeesSlice",
  async (prospectid, { rejectWithValue }) => {
    try {
      const response = await ApkLoanAssetService.getRequiredFeesService(
        prospectid
      );

      if (response.status === 200 && response.data) {
        return response.data;
      }

      notification.error({
        message: "Error",
        description: response?.data?.message || "Unexpected response!",
        duration: 3,
      });

      return rejectWithValue(response?.data?.message || "Unexpected response!");
    } catch (error) {
      const status = error?.response?.status || "Error";
      const statusText = error?.response?.statusText || "Unexpected error";

      notification.error({
        message: status,
        description: statusText,
        duration: 3,
      });

      return rejectWithValue(error?.response?.data?.message || statusText);
    }
  }
);

export const getEditAssetSlice = createAsyncThunk(
  "ApprovalKredit/getEditAssetSlice",
  async (prospectid, { rejectWithValue }) => {
    try {
      const response = await ApkLoanAssetService.getEditAssetService(
        prospectid
      );

      if (response.status === 200 && response.data) {
        return response.data;
      }

      notification.error({
        message: "Error",
        description: response?.data?.message || "Unexpected response!",
        duration: 3,
      });

      return rejectWithValue(response?.data?.message || "Unexpected response!");
    } catch (error) {
      const status = error?.response?.status || "Error";
      const statusText = error?.response?.statusText || "Unexpected error";

      notification.error({
        message: status,
        description: statusText,
        duration: 3,
      });

      return rejectWithValue(error?.response?.data?.message || statusText);
    }
  }
);

export const getAttributeValidationSlice = createAsyncThunk(
  "ApprovalKredit/getAttributeValidationSlice",
  async (prospectid, { rejectWithValue }) => {
    try {
      const response = await ApkLoanAssetService.getAttributeValidationService(
        prospectid
      );

      if (response.status === 200 && response.data) {
        return response.data;
      }

      notification.error({
        message: "Error",
        description: response?.data?.message || "Unexpected response!",
        duration: 3,
      });

      return rejectWithValue(response?.data?.message || "Unexpected response!");
    } catch (error) {
      const status = error?.response?.status || "Error";
      const statusText = error?.response?.statusText || "Unexpected error";

      notification.error({
        message: status,
        description: statusText,
        duration: 3,
      });

      return rejectWithValue(error?.response?.data?.message || statusText);
    }
  }
);

export const getMRPSlice = createAsyncThunk(
  "ApprovalKredit/getMRPSlice",
  async (prospectid, { rejectWithValue }) => {
    try {
      const response = await ApkLoanAssetService.getMRPService(prospectid);

      if (response.status === 200 && response.data) {
        return response.data;
      }

      notification.error({
        message: "Error",
        description: response?.data?.message || "Unexpected response!",
        duration: 3,
      });

      return rejectWithValue(response?.data?.message || "Unexpected response!");
    } catch (error) {
      const status = error?.response?.status || "Error";
      const statusText = error?.response?.statusText || "Unexpected error";

      notification.error({
        message: status,
        description: statusText,
        duration: 3,
      });

      return rejectWithValue(error?.response?.data?.message || statusText);
    }
  }
);

export const ApkLoanAssetSlice = createSlice({
  name: "apkLoanAsset",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
    resetStatusRespon: (state) => {
      state.statusRespon = 0;
    },
    resetMrpItem: (state) => {
      state.mrpItem = null;
    },
    setcreditStepKTA: (state, action) => {
      state.creditStepKTA = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getRequiredAssetDocSlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getRequiredAssetDocSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.requiredAssetDocList = action.payload;
        state.getCount = action.payload?.count || 0;
      })
      .addCase(getRequiredAssetDocSlice.rejected, (state) => {
        state.loading = false;
      })
      // Add ApkLoanAsset
      .addCase(addApkLoanAssetSlice.pending, (state) => {
        state.loadingAsset = true;
        state.noApkFAS = "";
      })
      .addCase(addApkLoanAssetSlice.fulfilled, (state, action) => {
        state.loadingAsset = false;
        state.redirect = "/";
        state.result = action.payload;
        state.showMessage = true;
        state.message = action.payload?.message || "";
        state.refreshList = true;
        state.statusRespon = action.payload?.status || 0;
      })
      .addCase(addApkLoanAssetSlice.rejected, (state, action) => {
        state.loadingAsset = false;
        state.result = action.payload || {};
        state.showMessage = true;
        state.noApkFAS = "";
      })
      // Edit ApkLoanAsset
      .addCase(editApkLoanAssetSlice.pending, (state) => {
        state.loadingAsset = true;
        state.noApkFAS = "";
      })
      .addCase(editApkLoanAssetSlice.fulfilled, (state, action) => {
        state.loadingAsset = false;
        state.redirect = "/";
        state.result = action.payload;
        state.showMessage = true;
        state.message = action.payload?.message || "";
        state.refreshList = true;
        state.statusRespon = action.payload?.status || 0;
      })
      .addCase(editApkLoanAssetSlice.rejected, (state, action) => {
        state.loadingAsset = false;
        state.result = action.payload || {};
        state.showMessage = true;
        state.noApkFAS = "";
      })
      // getRequiredFeesSlice
      .addCase(getRequiredFeesSlice.pending, (state) => {
        state.loadingRequiredFees = true;
        state.noApkFAS = "";
      })
      .addCase(getRequiredFeesSlice.fulfilled, (state, action) => {
        state.loadingRequiredFees = false;
        state.requiredAssetFeeList = action.payload;
        state.getCount = action.payload?.count || 0;
      })
      .addCase(getRequiredFeesSlice.rejected, (state, action) => {
        state.loadingRequiredFees = false;
        state.result = action.payload || {};
        state.showMessage = true;
        state.noApkFAS = "";
      })
      // Get Attribute Validation
      .addCase(getAttributeValidationSlice.pending, (state) => {
        state.loadingAssetRegis = true;
        state.noApkFAS = "";
      })
      .addCase(getAttributeValidationSlice.fulfilled, (state, action) => {
        // console.log("getAttributeValidationSlice fulfilled:", action.payload);

        state.loadingAssetRegis = false;
        state.attributeValidationItem = action.payload;
        state.getCount = action.payload?.count || 0;
        // Tampilkan alert sesuai kondisi
        if (state.attributeValidationItem.result === true) {
          notification.warning({
            message: "Data Duplikat",
            description:
              state.attributeValidationItem.message || "Duplicate Found!",
            placement: "topRight",
          });
        } else if (state.attributeValidationItem.result === false) {
          notification.success({
            message: "Tidak Ada Duplikat",
            description:
              state.attributeValidationItem.message || "No Duplicates Found!",
            placement: "topRight",
          });
        }
      })
      .addCase(getAttributeValidationSlice.rejected, (state, action) => {
        state.loadingAssetRegis = false;
        state.result = action.payload || {};
        state.showMessage = true;
        state.noApkFAS = "";
      })

      // getRequiredFeesSlice
      .addCase(getEditAssetSlice.pending, (state) => {
        state.loading = true;
        state.getEditAssetItem = [];
        state.attributeValidationItem = [];
        state.noApkFAS = "";
      })
      .addCase(getEditAssetSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.getEditAssetItem = action.payload;
        state.getCount = action.payload?.count || 0;
      })
      .addCase(getEditAssetSlice.rejected, (state, action) => {
        state.loading = false;
        state.getEditAssetItem = [];
        state.attributeValidationItem = [];
        state.result = action.payload || {};
        state.showMessage = true;
        state.noApkFAS = "";
      })
      // getMRPSlice
      .addCase(getMRPSlice.pending, (state) => {
        state.loading = true;
        state.mrpItem = 0;
      })
      .addCase(getMRPSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.mrpItem = action.payload?.message;
        // state.getCount = action.payload?.count || 0;
      })
      .addCase(getMRPSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload || {};
        state.showMessage = true;
        state.mrpItem = 0;
        state.noApkFAS = "";
      });
  },
});

export const {
  showNotification,
  hideNotification,
  showLoading,
  resetStatusRespon,
  setcreditStepKTA,
  resetMrpItem,
} = ApkLoanAssetSlice.actions;

export default ApkLoanAssetSlice.reducer;
